import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    approvals: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_APPROVAL_SELECT_IDS (store, ids) {
      store.approvals.selectIds = ids
    },
    REMOVE_APPROVAL_SELECT_IDS (store, ids) {
      store.approvals.selectIds = store.approvals.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_APPROVAL_SELECT_ID (store, id) {
      store.approvals.selectId = id
    },
    SET_APPROVAL_FILTERS (store, filters) {
      store.approvals.filters = filters
    },
    SET_APPROVAL_PAGINATE (store, val) {
      store.approvals.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getApprovals: (store, getters) => {
      return store.approvals.selectIds.map((id) => {
        return getters['entities/approvals/find'](id)
      })
    },
    getApprovalsFilters: (store, getters) => {
      return store.approvals.filters
    },
    getApprovalsPaginate: (store, getters) => {
      return store.approvals.paginate
    },
    getApproval: (store, getters) => {
      return getters['entities/approvals/find'](store.approvals.selectId) || {}
    }
  },
  actions: {
    /*
    selectApprovals
    */
    selectApprovals ({commit, dispatch, getters, state}, filters) {
      return dispatch('getApprovals', { ...filters, abortid: 'select-approvals' })
      .then((response) => {
        commit('SET_APPROVAL_FILTERS', filters)
        commit('SET_APPROVAL_PAGINATE', response)
        commit('SET_APPROVAL_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectApprovals
    */
    refreshSelectApprovals ({commit, dispatch, getters, state}) {
      return dispatch('selectApprovals', getters.getApprovalsFilters)
    },
    /*
    selectApproval
    */
    selectApproval ({commit, dispatch, getters, state}, id) {
      return dispatch('getApprovalById', id)
      .then((response) => {
        commit('SET_APPROVAL_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getApprovals
    */
    getApprovals ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/approvals`, { params: filters })
      .then((response) => {
        return dispatch('entities/approvals/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.approvals || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getApprovalById
    */
    getApprovalById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/approvals/${id}`)
      .then((response) => {
        return dispatch('entities/approvals/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.approvals[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Approval.js